var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackFid = function SvgBlackFid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.853 6A2.353 2.353 0 0 0 2.5 8.353v15.294C2.5 24.947 3.553 26 4.853 26h23.53c1.299 0 2.352-1.053 2.352-2.353V8.353c0-1.3-1.053-2.353-2.353-2.353zm10.7 15.912c.433-.73 1.335-2.248.368-5.905-.351-1.327-.608-3.454 1.76-6.007-.673.976-1.126 2.433-.228 5.834.685 2.596-.9 5.066-1.953 6.166z",
    clipRule: "evenodd"
  })));
};
export default SvgBlackFid;